import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import HttpClient from '@/api/HttpClient';

const httpClient = new HttpClient();

const getRejectsApi = async (): Promise<any[]> => {
  const response = await httpClient.get('api/reject/get', {});
  return response.data.data || response.data || [];
};

const getRejectsByLocationApi = async (locationId: number): Promise<any[]> => {
  const response = await httpClient.get('api/reject/get-by-location', { locationId });
  return response.data.data || response.data || [];
};

const reportRejectApi = async (payload: any): Promise<any> => {
  const response = await httpClient.post('api/reject/report', payload);
  return response.data;
};

const updateRejectApi = async (payload: any): Promise<any> => {
  const response = await httpClient.post('api/reject/update', payload);
  return response.data;
};

export const useRejects = () => {
  return useQuery({
    queryKey: ['rejects'],
    queryFn: getRejectsApi,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
};

export const useRejectsByLocation = (locationId: number) => {
  return useQuery({
    queryKey: ['rejects', 'location', locationId],
    queryFn: () => getRejectsByLocationApi(locationId),
    enabled: !!locationId,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
};

export const useReportReject = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: reportRejectApi,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['rejects'] });
      if (variables.locationId) {
        queryClient.invalidateQueries({ queryKey: ['rejects', 'location', variables.locationId] });
      }
      queryClient.invalidateQueries({ queryKey: ['location-readings'] });
    },
  });
};

export const useUpdateReject = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateRejectApi,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['rejects'] });
      if (variables.locationId) {
        queryClient.invalidateQueries({ queryKey: ['rejects', 'location', variables.locationId] });
      }
      queryClient.invalidateQueries({ queryKey: ['location-readings'] });
    },
  });
};
